export const BASE_HEADERS = {
  'Content-Type': 'application/json',
  'dua-version': '2',
  'app-version': '6',
};
